export const AuthApplicationCodes = {  
  Sales: 'SALES',
} as const;

export type AuthApplicationCode = (typeof AuthApplicationCodes)[keyof typeof AuthApplicationCodes];
